import {
  Box,
  Grid,
  Typography,
  Button,
} from "@mui/material";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";

export const FooterContacto = () => {
  return (
    <Box
      sx={{
        mt: 8,
        borderRadius: { xs: "25px", md: "35px" },
        overflow: "hidden",
        position: "relative",
        background: "linear-gradient(135deg,#484a75 0%,#3d3f63 100%)",
        color: "#fff",
        px: { xs: 3, sm: 4, md: 6 },
        py: { xs: 4, md: 5 },

        "&::before": {
          content: '""',
          position: "absolute",
          width: { xs: 180, md: 350 },
          height: { xs: 180, md: 350 },
          borderRadius: "50%",
          background: "rgba(255,255,255,.04)",
          top: { xs: -80, md: -180 },
          right: { xs: -70, md: -120 },
        },

        "&::after": {
          content: '""',
          position: "absolute",
          width: { xs: 140, md: 260 },
          height: { xs: 140, md: 260 },
          borderRadius: "50%",
          background: "rgba(255,255,255,.03)",
          bottom: { xs: -70, md: -120 },
          left: { xs: -50, md: -80 },
        },
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="center"
        position="relative"
        zIndex={2}
      >
        {/* Información */}
        <Grid size={{ xs: 12, md: 7 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              alignItems: "center",
              gap: 3,
              textAlign: {
                xs: "center",
                sm: "left",
              },
            }}
          >
            <Box
              sx={{
                width: { xs: 90, md: 110 },
                height: { xs: 90, md: 110 },
                borderRadius: "50%",
                bgcolor: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
              }}
            >
              <WhatsAppIcon
                sx={{
                  color: "#25D366",
                  fontSize: {
                    xs: 55,
                    md: 70,
                  },
                }}
              />
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  lineHeight: 1.2,
                  fontSize: {
                    xs: "1.5rem",
                    sm: "2rem",
                    md: "2.5rem",
                  },
                }}
              >
                WhatsApp Institucional
              </Typography>

              <Typography
                sx={{
                  mt: 1,
                  opacity: .9,
                  maxWidth: 500,
                  mx: {
                    xs: "auto",
                    sm: 0,
                  },
                  fontSize: {
                    xs: ".9rem",
                    sm: "1rem",
                    md: "1.15rem",
                  },
                }}
              >
                Nuestro equipo responderá todas tus consultas durante el horario de atención.
              </Typography>

              <Box
                sx={{
                  mt: 3,
                  display: "flex",
                  justifyContent: {
                    xs: "center",
                    sm: "flex-start",
                  },
                  alignItems: "center",
                  gap: 1.5,
                  flexWrap: "wrap",
                }}
              >
                <PhoneInTalkOutlinedIcon
                  sx={{
                    fontSize: 30,
                  }}
                />

                <Typography
                  sx={{
                    fontWeight: 700,
                    lineHeight: 1,
                    fontSize: {
                      xs: "1.4rem",
                      sm: "1.8rem",
                      md: "2.2rem",
                    },
                  }}
                >
                  +56 9 3238 5589
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Botón */}
        <Grid size={{ xs: 12, md: 5 }}>
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: "22px",
              p: { xs: 2.5, md: 3.5 },
              textAlign: "center",
              boxShadow: "0 20px 40px rgba(0,0,0,.18)",
            }}
          >
            <Button
            component="a"
  href="https://wa.me/56932385589"
  target="_blank"
  rel="noopener noreferrer"
              fullWidth
              startIcon={<WhatsAppIcon />}
              variant="contained"
              sx={{
                bgcolor: "#25D366",
                color: "#fff",
                py: 1.8,
                borderRadius: "14px",
                textTransform: "none",
                fontWeight: 700,
                fontSize: {
                  xs: ".95rem",
                  md: "1.15rem",
                },

                "&:hover": {
                  bgcolor: "#20be5a",
                },
              }}
            >
              Hablar por WhatsApp
            </Button>

            <Typography
              sx={{
                mt: 2,
                color: "#666",
                fontSize: {
                  xs: ".85rem",
                  md: ".95rem",
                },
              }}
            >
              Respuesta rápida y directa.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};